export function getStartMonth(availableDates) {
  const sorted = [...availableDates].sort();
  if (sorted.length === 0) {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth()
    };
  }
  const [year, month] = sorted[0].split('-').map(Number);
  return {
    year,
    month: month - 1
  };
}